import type { Status } from '../types';
import type { Words } from '../copy';
import { fmtTime } from '../format';

interface Props {
  status: Status;
  hasAudio: boolean;
  isPlaying: boolean;
  playhead: number;
  duration: number;
  recElapsed: number;
  quantized: boolean;
  showOriginal: boolean;
  hasLoops: boolean;
  hint: string;
  w: Words;
  onRecord: () => void;
  onStopRecord: () => void;
  onImport: () => void;
  onPlay: () => void;
  onStop: () => void;
  onPlayLoops: () => void;
  onCompare: (original: boolean) => void;
}

export default function Transport(p: Props) {
  const rec = p.status === 'recording';

  return (
    <div className="transport">
      {rec ? (
        <button className="btn primary" onClick={p.onStopRecord}>
          ■ Arrêter
        </button>
      ) : (
        <button className="btn rec" onClick={p.onRecord}>
          ● Enregistrer
        </button>
      )}

      <button className="btn" onClick={p.onImport} disabled={rec}>
        Importer…
      </button>

      <div className="vrule" />

      <button
        className="btn play"
        onClick={p.isPlaying ? p.onStop : p.onPlay}
        disabled={!p.hasAudio}
        aria-label={p.isPlaying ? 'Arrêter la lecture' : 'Écouter'}
      >
        {p.isPlaying ? '■ Stop' : '▶ Écouter'}
      </button>

      <button className="btn icon" onClick={p.onPlayLoops} disabled={!p.hasAudio || !p.hasLoops}>
        ▶ {p.w.loopsLower}
      </button>

      <span className="mono" style={{ fontSize: 13, color: 'var(--muted)' }}>
        {rec
          ? fmtTime(p.recElapsed)
          : p.hasAudio
            ? `${fmtTime(p.playhead)} / ${fmtTime(p.duration)}`
            : '—'}
      </span>

      <div className="grow" />

      <span className="t-hint" style={{ fontSize: 12, color: 'var(--dim)' }}>{p.hint}</span>

      {p.quantized && (
        <div className="seg" role="group" aria-label="Comparer avant / après">
          <button
            className={p.showOriginal ? 'on neutral' : ''}
            onClick={() => p.onCompare(true)}
          >
            {p.w.before}
          </button>
          <button
            className={!p.showOriginal ? 'on alt' : ''}
            onClick={() => p.onCompare(false)}
          >
            {p.w.after}
          </button>
        </div>
      )}
    </div>
  );
}
